import SectionTitle from "../components/SectionTitle";
import PageSeo from "../components/PageSeo";
import Reveal from "../components/Reveal";

export default function Privacidad() {
  return (
    <div>
      <PageSeo
        title="Política de Privacidad"
        description="Política de privacidad de la Asociación Pequeño Fresno: tratamiento de datos personales conforme al RGPD y la LOPDGDD."
        path="/privacidad"
      />
      <section className="max-w-3xl mx-auto px-6">
        <SectionTitle>~ política de privacidad ~</SectionTitle>

        <Reveal>
          <div className="prose-body text-[color:var(--text)] space-y-8">
            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">1. Responsable del tratamiento</h2>
              <ul>
                <li><strong>Identidad:</strong> Asociación Pequeño Fresno Esclerosis Tuberosa</li>
                <li><strong>Número de inscripción:</strong> CV-01-066518-A</li>
                <li><strong>NIF:</strong> G75532028</li>
                <li><strong>Domicilio:</strong> Calle Palangre número 13, bungalow 35, 03540 Alicante, España</li>
                <li><strong>Email de contacto:</strong> info@pequenofresno.net</li>
              </ul>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">2. Datos que recogemos y finalidad</h2>
              <p>Tratamos los datos personales que nos facilitas voluntariamente a través de los formularios del sitio web, con las siguientes finalidades:</p>
              <div className="space-y-3 mt-3">
                <div className="pf-soft rounded-xl p-4">
                  <strong>Formulario de contacto</strong>
                  <ul className="mt-2 text-sm">
                    <li><strong>Datos:</strong> nombre, email, asunto y mensaje</li>
                    <li><strong>Finalidad:</strong> responder a tu consulta</li>
                    <li><strong>Base legal:</strong> consentimiento (Art. 6.1.a RGPD)</li>
                    <li><strong>Conservación:</strong> 1 año desde el último contacto</li>
                  </ul>
                </div>
                <div className="pf-soft rounded-xl p-4">
                  <strong>Suscripción a newsletter</strong>
                  <ul className="mt-2 text-sm">
                    <li><strong>Datos:</strong> email</li>
                    <li><strong>Finalidad:</strong> enviarte información sobre eventos, novedades y actividades de la asociación</li>
                    <li><strong>Base legal:</strong> consentimiento (Art. 6.1.a RGPD)</li>
                    <li><strong>Conservación:</strong> hasta que retires tu consentimiento</li>
                  </ul>
                </div>
                <div className="pf-soft rounded-xl p-4">
                  <strong>Donaciones</strong>
                  <ul className="mt-2 text-sm">
                    <li><strong>Datos:</strong> los que gestione directamente DonorBox como responsable independiente (nombre, email, importe, método de pago)</li>
                    <li><strong>Finalidad:</strong> tramitar la donación y emitir certificado fiscal si corresponde</li>
                    <li><strong>Base legal:</strong> ejecución de contrato / cumplimiento de obligaciones legales fiscales</li>
                    <li><strong>Conservación:</strong> plazos legales fiscales (mínimo 5 años)</li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">3. Destinatarios y cesiones</h2>
              <p>Tus datos se tratan con confidencialidad y no se ceden a terceros salvo obligación legal. Utilizamos los siguientes proveedores como <em>encargados del tratamiento</em>:</p>
              <ul className="mt-2">
                <li><strong>SendGrid (Twilio Inc.):</strong> envío de notificaciones y correos transaccionales. Datos alojados en EE.UU. bajo <em>Data Privacy Framework</em>.</li>
                <li><strong>MongoDB / hosting:</strong> almacenamiento seguro de los mensajes y suscripciones recibidos.</li>
                <li><strong>DonorBox:</strong> proveedor independiente que gestiona las donaciones bajo su propia política de privacidad.</li>
                <li><strong>Google (autenticación del panel):</strong> solo para el acceso administrativo restringido de la asociación.</li>
              </ul>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">4. Transferencias internacionales</h2>
              <p>Algunos de los proveedores citados (SendGrid, Google) pueden tratar datos fuera del Espacio Económico Europeo. En esos casos, las transferencias se realizan bajo las garantías previstas por el RGPD (cláusulas contractuales tipo aprobadas por la Comisión Europea y/o adhesión al <em>EU-US Data Privacy Framework</em>).</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">5. Tus derechos</h2>
              <p>Puedes ejercer en cualquier momento y de forma gratuita los siguientes derechos:</p>
              <ul>
                <li><strong>Acceso</strong> a los datos que tratamos sobre ti</li>
                <li><strong>Rectificación</strong> si son inexactos o están incompletos</li>
                <li><strong>Supresión</strong> (“derecho al olvido”) cuando ya no sean necesarios</li>
                <li><strong>Oposición</strong> al tratamiento en determinados supuestos</li>
                <li><strong>Limitación</strong> del tratamiento</li>
                <li><strong>Portabilidad</strong>: recibir tus datos en formato estructurado</li>
                <li><strong>Retirar el consentimiento</strong> en cualquier momento, sin que ello afecte a la licitud del tratamiento previo</li>
              </ul>
              <p>Para ejercerlos, escríbenos a <a href="mailto:info@pequenofresno.net" className="link-underline text-[color:var(--brand)]">info@pequenofresno.net</a> indicando el derecho que deseas ejercer y adjuntando copia de un documento identificativo.</p>
              <p>Si consideras que el tratamiento de tus datos no se ajusta a la normativa, tienes derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> en <a href="https://www.aepd.es" target="_blank" rel="noreferrer" className="link-underline text-[color:var(--brand)]">www.aepd.es</a>.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">6. Menores de edad</h2>
              <p>No recogemos deliberadamente datos personales de menores de 14 años. Si detectas que se ha facilitado información de un menor sin autorización de sus tutores, contacta con nosotros y procederemos a suprimirla.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">7. Medidas de seguridad</h2>
              <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos frente a pérdida, acceso no autorizado, alteración o difusión: cifrado en tránsito (HTTPS), acceso restringido al panel administrativo mediante autenticación, y copias de seguridad periódicas.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">8. Cookies y analítica</h2>
              <p>Este sitio utiliza únicamente cookies técnicas estrictamente necesarias para el funcionamiento (por ejemplo, la sesión del panel de administración y la preferencia de tema claro/oscuro). Estas cookies están exentas de consentimiento según la normativa europea.</p>
              <p>Contamos con un sistema de <strong>analítica propia y anónima</strong> para conocer el número de visitas al sitio: se guarda un identificador temporal en <em>sessionStorage</em> del navegador (no es una cookie y desaparece al cerrar la pestaña), sin utilizar cookies publicitarias ni de terceros, ni almacenar direcciones IP identificables. Los datos agregados se conservan como máximo 12 meses.</p>
              <p>Si en el futuro incorporáramos cookies analíticas o de terceros, se publicará una política de cookies detallada y un banner de consentimiento.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">9. Cambios en esta política</h2>
              <p>Podemos actualizar esta política para reflejar cambios legales o de servicios. Publicaremos la versión vigente en esta misma página indicando la fecha de última actualización.</p>
            </div>

            <p className="text-sm italic text-[color:var(--text-soft)]">Última actualización: 19 de agosto de 2026</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
